import { render } from "./Simcards.vue?vue&type=template&id=6d7c335e"
import script from "./Simcards.vue?vue&type=script&lang=js"
export * from "./Simcards.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__